module.exports = __webpack_public_path__ + "static/media/rc_th.63245d0c.png";